const resources = {
  "en": {
    "menu": {
      "home": "Home",
      "notifications": "Notifications",
      "tasksToConfirm": "Tasks to confirm",
      "taskEvents": "Task events",
      "deadlines": "Deadlines",
      "cashFlow": "Cash Flow",
      "transactionsHub": "Transactions Hub",
      "financeAnalysis": "Finance Analysis",
      "expenses": "Expenses",
      "income": "Income",
      "liabilities": "Liabilities",
      "obligations": "Obligations",
      "accounts": "Accounts",
      "manage": "Manage",
      "manageDeadlines": "Manage Deadlines",
      "history": "History",
      "debts": "Debts",
      "debtPayoff": "Debt Payoff",
      "recurring": "Recurring",
      "recurrentHub": "Recurring Hub",
      "forecast": "Forecast",
      "view": "View",
      "summary": "Summary",
      "summaryCalendar": "Forecast",
      "toolsHub": "Tools",
      "gptAnalysis": "GPT Analysis",
      "aiTools": "AI tools",
      "tempoMint": "TempoMint",
      "budgeting": "Budgeting",
      "budgets": "Budgets",
      "groups": "Groups",
      "rewards": "Rewards",
      "financeGoals": "My Finance Goals",
      "growthProgram": "Growth Program",
      "skillsFactory": "Skills Factory",
      "personalCircle": "Personal Circle",
      "inviteFriend": "Invite a Friend",
      "forecastAiHistory": "Forecast AI History",
      "financeAnalysisHistory": "Finance Analysis History",
      "activityLog": "Activity Log",
      "balanceRollout": "Balance Rollout",
      "forecastRollout": "Forecast Rollout",
      "deleteAccount": "Delete account",
      "insights": "Insights",
      "myInsights": "My Insights",
      "publicInsights": "Public Insights",
      "subscribe": "Subscription",
      "billingHistory": "Billing History",
      "passkeys": "Passkeys",
      "settings": "Settings",
      "supportHelp": "Support & Help",
      "categories": "Categories",
      "closingHistory": "Closing History",
      "profile": "Profile Settings",
      "toggleTheme": "Toggle Theme",
      "logout": "Logout",
      "menu": "Menu",
      "locked": {
        "title": "This section is locked",
        "reasonFallback": "Complete the previous onboarding step to unlock this section.",
        "nextAction": "Next action",
        "takeMeThere": "Take me there",
        "cancel": "Cancel"
      },
      "unlock": {
        "title": "Step completed",
        "description": "Great progress. New sections are now available for you.",
        "completed": "Completed step:",
        "unlocked": "Now unlocked:",
        "ok": "OK"
      }
    }
  },
  "uk": {
    "menu": {
      "home": "Головна",
      "notifications": "Сповіщення",
      "tasksToConfirm": "Підтвердження задач",
      "taskEvents": "Події задач",
      "deadlines": "Дедлайни",
      "cashFlow": "Грошові потоки",
      "transactionsHub": "Хаб транзакцій",
      "financeAnalysis": "Фінансовий аналіз",
      "expenses": "Витрати",
      "income": "Дохід",
      "liabilities": "Зобов’язання",
      "obligations": "Зобов’язання",
      "accounts": "Рахунки",
      "manage": "Керування",
      "history": "Історія",
      "debts": "Борги",
      "debtPayoff": "Погашення боргів",
      "recurring": "Повторювані",
      "recurrentHub": "Хаб регулярних записів",
      "forecast": "Прогноз",
      "view": "Перегляд",
      "summary": "Підсумок",
      "summaryCalendar": "Календар підсумків",
      "toolsHub": "Інструменти",
      "gptAnalysis": "GPT-аналіз",
      "aiTools": "AI-інструменти",
      "tempoMint": "TempoMint",
      "budgeting": "Бюджетування",
      "budgets": "Бюджети",
      "groups": "Групи",
      "rewards": "Винагороди",
      "financeGoals": "Фінансові цілі",
      "growthProgram": "Програма росту",
      "skillsFactory": "Фабрика навичок",
      "personalCircle": "Особисте коло",
      "inviteFriend": "Запросити друга",
      "forecastAiHistory": "Історія Forecast AI",
      "financeAnalysisHistory": "Історія Finance Analysis",
      "activityLog": "Журнал активності",
      "balanceRollout": "Balance Rollout",
      "forecastRollout": "Роллаут прогнозу",
      "deleteAccount": "Видалити акаунт",
      "insights": "Інсайти",
      "myInsights": "Мої інсайти",
      "publicInsights": "Публічні інсайти",
      "subscribe": "Підписка",
      "billingHistory": "Історія оплат",
      "passkeys": "Пасключі",
      "settings": "Налаштування",
      "supportHelp": "Підтримка та допомога",
      "categories": "Категорії",
      "closingHistory": "Історія закриття",
      "profile": "Налаштування профілю",
      "toggleTheme": "Змінити тему",
      "logout": "Вийти",
      "menu": "Меню",
      "locked": {
        "title": "Цей розділ заблокований",
        "reasonFallback": "Завершіть попередній крок онбордингу, щоб відкрити цей розділ.",
        "nextAction": "Наступна дія",
        "takeMeThere": "Перейти",
        "cancel": "Скасувати"
      },
      "unlock": {
        "title": "Крок завершено",
        "description": "Чудовий прогрес. Для вас відкрито нові розділи.",
        "completed": "Завершений крок:",
        "unlocked": "Тепер доступно:",
        "ok": "OK"
      }
    }
  }
};

export default resources;
